import { render } from "./x.vue?vue&type=template&id=16b6b88a"
const script = {}
script.render = render

export default script